export default "{{ minutes || '--' }}:{{ seconds || '--' }}\n"